// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3cYEN","topBottomGutter":"Layout_topBottomGutter__1xMOb"};